<template>
    <!-- 粉丝 -->
    <div class="cont-fensi cont-haoyou" v-if="userId == currentUserId">
        <ul class="user-much-num clearfix">
            <li :class="{active: showIndex === 0}" @click="showEvent(0)"><span>好友列表</span></li>
            <li :class="{active: showIndex === 1}" @click="showEvent(1)" v-if="undoNum>0" class="red"><span>待处理请求</span>
            </li>
            <li :class="{active: showIndex === 1}" @click="showEvent(1)" v-else><span>待处理请求</span></li>
            <li :class="{active: showIndex === 2}" @click="showEvent(2)"><span>已发出请求</span></li>
            <li :class="{active: showIndex === 3}" @click="showEvent(3)"><span>加好友</span></li>
            <li :class="{active: showIndex === 4}" @click="showEvent(4)"><span>黑名单</span></li>
        </ul>
        <div class="friend-list" v-if="showIndex === 0">
            <template v-if="total>0" v-loading="fullscreenLoading">
                <div class="fans-item-one clearfix" v-for="(item, index) in tableData" :key="index">
                    <router-link target="_blank" :to="{path:'/home', query: {userId:item.userInfo.userId}}"
                                 class="avatar-f">
                        <img class="ava" :src="`http://iss.21teacher.com/avatar/125/${item.userInfo.userId}/20.jpg`"
                             alt="">
                    </router-link>
                    <div class="img-list clearfix" v-for="(production,subIndex) in tableData[index].productionList"
                         :key="subIndex">
                        <router-link :to="{path:'/worksdetail',query:{id:production.id,plate:production.belongSection}}" target="_blank"
                                     class="demo-img"><img :src="production.productionCover" alt="">
                        </router-link>
                    </div>
                    <div class="user-infoes">
                        <div class="user-name">
                            <router-link target="_blank" :to="{path:'/home', query: {userId:item.userInfo.userId}}">
                                {{item.userInfo.userName}}
                            </router-link>
                        </div>
                        <div class="shanchang">擅长领域：{{item.userInfo.introduction}}</div>
                        <div class="works-fans">作品 {{item.userInfo.productionsCount}} | 文章
                            {{item.userInfo.archivesCount}} | 粉丝 {{item.userInfo.followersCount}}
                        </div>
                        <div class="qianming">个性签名：{{item.userInfo.signature}}</div>
                        <div class="btns" v-if="status == 2">
                            <!--<el-button  @click="toChart(item.friendId)">发消息</el-button>-->
                            <el-button @click="blackFriend(item,index)">移入黑名单</el-button>
                            <el-button @click="delFriend(item,index)">删除</el-button>
                        </div>
                    </div>
                </div>
                <div class="pagintion-f">
                    <el-pagination
                            background
                            @current-change="statusList"
                            layout="prev, pager, next"
                            :current-page="pageIndex"
                            :page-size="pageSize"
                            :hide-on-single-page="true"
                            :total="total">
                    </el-pagination>
                </div>
            </template>
            <div v-else class="common-no-data">
                <img class="img" :src="require('@/assets/images/empty_img.png')" alt="">
                <span class="words">抱歉！您访问的页面暂无数据</span>
            </div>
        </div>
        <div class="daichuli-list" v-if="showIndex === 1">
            <template v-if="total>0" v-loading="fullscreenLoading">
                <div class="fans-item-one clearfix" v-for="(item, index) in tableData" :key="index">
                    <router-link target="_blank" :to="{path:'/home', query: {userId:item.userInfo.userId}}"
                                 class="avatar-f">
                        <img class="ava" :src="`http://iss.21teacher.com/avatar/125/${item.userInfo.userId}/20.jpg`"
                             alt="">
                    </router-link>
                    <div class="img-list clearfix" v-for="(production,subIndex) in tableData[index].productionList"
                         :key="subIndex">
                        <router-link :to="{path:'/worksdetail',query:{id:production.id,plate:production.belongSection}}" target="_blank"
                                     class="demo-img"><img :src="production.productionCover" alt="">
                        </router-link>
                    </div>
                    <div class="user-infoes">
                        <div class="user-name">
                            <router-link target="_blank" :to="{path:'/home', query: {userId:item.userInfo.userId}}">
                                {{item.userInfo.userName}}
                            </router-link>
                        </div>
                        <div class="shanchang">擅长领域：{{item.userInfo.introduction}}</div>
                        <div class="works-fans">作品 {{item.userInfo.productionsCount}} | 文章
                            {{item.userInfo.archivesCount}} | 粉丝 {{item.userInfo.followersCount}}
                        </div>
                        <div class="qianming">个性签名：{{item.userInfo.signature}}</div>
                        <div class="btns" v-if="status == 1">
                            <el-button @click="updateStatus(item,index,2)">同意</el-button>
                            <el-button @click="updateStatus(item,index,3)">拒绝</el-button>
                        </div>
                    </div>
                </div>
                <div class="pagintion-f">
                    <el-pagination
                            background
                            @current-change="statusList"
                            layout="prev, pager, next"
                            :current-page="pageIndex"
                            :page-size="pageSize"
                            :hide-on-single-page="true"
                            :total="total">
                    </el-pagination>
                </div>
            </template>
            <div v-else class="common-no-data">
                <img class="img" :src="require('@/assets/images/empty_img.png')" alt="">
                <span class="words">抱歉！您访问的页面暂无数据</span>
            </div>
        </div>
        <div class="yifachu-list" v-if="showIndex === 2">
            <template v-if="total>0" v-loading="fullscreenLoading">
                <div class="fans-item-one clearfix" v-for="(item, index) in tableData" :key="index">
                    <router-link target="_blank" :to="{path:'/home', query: {userId:item.userInfo.userId}}"
                                 class="avatar-f">
                        <img class="ava" :src="`http://iss.21teacher.com/avatar/125/${item.userInfo.userId}/20.jpg`"
                             alt="">
                    </router-link>
                    <div class="img-list clearfix" v-for="(production,subIndex) in tableData[index].productionList"
                         :key="subIndex">
                        <router-link :to="{path:'/worksdetail',query:{id:production.id,plate:production.belongSection}}" target="_blank"
                                     class="demo-img"><img :src="production.productionCover" alt="">
                        </router-link>
                    </div>
                    <div class="user-infoes">
                        <div class="user-name">
                            <router-link target="_blank" :to="{path:'/home', query: {userId:item.userInfo.userId}}">
                                {{item.userInfo.userName}}
                            </router-link>
                        </div>
                        <div class="shanchang">擅长领域：{{item.userInfo.introduction}}</div>
                        <div class="works-fans">作品 {{item.userInfo.productionsCount}} | 文章
                            {{item.userInfo.archivesCount}} | 粉丝 {{item.userInfo.followersCount}}
                        </div>
                        <div class="qianming">个性签名：{{item.userInfo.signature}}</div>
                        <div class="btns" v-if="status == 4">
                            <el-button style="cursor:auto" >请求中</el-button>
                        </div>
                    </div>
                </div>
                <div class="pagintion-f">
                    <el-pagination
                            background
                            @current-change="statusList"
                            layout="prev, pager, next"
                            :current-page="pageIndex"
                            :page-size="pageSize"
                            :hide-on-single-page="true"
                            :total="total">
                    </el-pagination>
                </div>
            </template>
            <div v-else class="common-no-data">
                <img class="img" :src="require('@/assets/images/empty_img.png')" alt="">
                <span class="words">抱歉！您访问的页面暂无数据</span>
            </div>
        </div>
        <div class="jiahaoyou-list" v-if="showIndex === 3 ">
            <div class="search-user-ipt">
                <el-input
                        size="large"
                        placeholder="搜索添加好友"
                        prefix-icon="el-icon-search"
                        v-model="username"
                >
                    <el-button slot="append" @click="search(1)" icon="el-icon-search"></el-button>
                </el-input>
            </div>
            <template v-if="total>0" v-loading="fullscreenLoading">
                <div class="fans-item-one clearfix" v-for="(item, index) in tableData" :key="index">
                    <router-link target="_blank" :to="{path:'/home', query: {userId:item.userInfo.userId}}"
                                 class="avatar-f">
                        <img class="ava" :src="`http://iss.21teacher.com/avatar/125/${item.userInfo.userId}/20.jpg`"
                             alt="">
                    </router-link>
                    <div class="img-list clearfix" v-for="(production,subIndex) in tableData[index].productionList"
                         :key="subIndex">
                        <router-link :to="{path:'/worksdetail',query:{id:production.id,plate:production.belongSection}}" target="_blank"
                                     class="demo-img"><img :src="production.productionCover" alt="">
                        </router-link>
                    </div>
                    <div class="user-infoes">
                        <div class="user-name">
                            <router-link target="_blank" :to="{path:'/home', query: {userId:item.userInfo.userId}}">
                                {{item.userInfo.userName}}
                            </router-link>
                        </div>
                        <div class="shanchang">擅长领域：{{item.userInfo.introduction}}</div>
                        <div class="works-fans">作品 {{item.userInfo.productionsCount}} | 文章
                            {{item.userInfo.archivesCount}} | 粉丝 {{item.userInfo.followersCount}}
                        </div>
                        <div class="qianming">个性签名：{{item.userInfo.signature}}</div>
                        <div class="btns" v-if="currentUserId != item.friendId">
                            <el-button v-if="item.friendStatus == 4" @click="addFriend(item,index)">申请</el-button>
                            <!--<el-button v-else-if="item.friendStatus == 2" @click="toChart(item.friendId)">发消息</el-button>-->
                            <el-button v-else-if="item.friendStatus == 1" style="cursor:auto">请求中</el-button>
                        </div>
                    </div>
                </div>
                <div class="pagintion-f">
                    <el-pagination
                            background
                            @current-change="search"
                            layout="prev, pager, next"
                            :current-page="pageIndex"
                            :page-size="pageSize"
                            :hide-on-single-page="true"
                            :total="total">
                    </el-pagination>
                </div>
            </template>
            <div v-else class="common-no-data">
                <img class="img" :src="require('@/assets/images/empty_img.png')" alt="">
                <span class="words">抱歉！您访问的页面暂无数据</span>
            </div>
        </div>
        <div class="yifachu-list" v-if="showIndex === 4">
            <template v-if="total>0" v-loading="fullscreenLoading">
                <div class="fans-item-one clearfix" v-for="(item, index) in tableData" :key="index">
                    <router-link target="_blank" :to="{path:'/home', query: {userId:item.userInfo.userId}}"
                                 class="avatar-f">
                        <img class="ava" :src="`http://iss.21teacher.com/avatar/125/${item.userInfo.userId}/20.jpg`"
                             alt="">
                    </router-link>
                    <div class="img-list clearfix" v-for="(production,subIndex) in tableData[index].productionList"
                         :key="subIndex">
                        <router-link :to="{path:'/worksdetail',query:{id:production.id,plate:production.belongSection}}" target="_blank"
                                     class="demo-img"><img :src="production.productionCover" alt="">
                        </router-link>
                    </div>
                    <div class="user-infoes">
                        <div class="user-name">
                            <router-link target="_blank" :to="{path:'/home', query: {userId:item.userInfo.userId}}">
                                {{item.userInfo.userName}}
                            </router-link>
                        </div>
                        <div class="shanchang">擅长领域：{{item.userInfo.introduction}}</div>
                        <div class="works-fans">作品 {{item.userInfo.productionsCount}} | 文章
                            {{item.userInfo.archivesCount}} | 粉丝 {{item.userInfo.followersCount}}
                        </div>
                        <div class="qianming">个性签名：{{item.userInfo.signature}}</div>
                        <div class="btns">
                            <el-button @click="delBlack(item,index)">移出黑名单</el-button>
                        </div>
                    </div>
                </div>
                <div class="pagintion-f">
                    <el-pagination
                            background
                            @current-change="blackList"
                            layout="prev, pager, next"
                            :current-page="pageIndex"
                            :page-size="pageSize"
                            :hide-on-single-page="true"
                            :total="total">
                    </el-pagination>
                </div>
            </template>
            <div v-else class="common-no-data">
                <img class="img" :src="require('@/assets/images/empty_img.png')" alt="">
                <span class="words">抱歉！您访问的页面暂无数据</span>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import axios from 'axios';
    import vue from 'vue';

    import { mapState } from "vuex";
    import updateTdk from "@/utils/tdk";

    vue.prototype.$axios = axios;
    import global_ from '@/api/global'

    export default {
        components: {},
        data() {
            return {
                headTitle: "title---rrdh",
                headKeywords: "keywords---rrdh",
                headDesc: "description---rrdh",
                isMounted: false, //for control not ssr render

                showIndex: 0,
                username: '',
                tableData: [],
                total: 0,
                fullscreenLoading: true,
                pageIndex: 1,
                pageSize: 5,
                callbackurl: "",
                userId: 0,
                currentUserId: 0,
                status: 2,
                undoNum: 0
            }
        },
        computed: {
            ...mapState(["userDetail"])
        },
        tdk() {
            return {
                title: this.headTitle,
                description: this.headDesc,
                keywords: this.headKeywords,
                ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
            };
        },
        serverPrefetch() {
            return this.fetchData();
        },
        destroyed() {
            this.$store.commit("SET_USER_DETAIL", { detail: null });
        },
        beforeRouteUpdate(to, from, next) {
            // 一般建议路由变更采用计算属性或者store直接绑定
            // 特殊情况处理可以采用如下方案 重新注册数据返回处理
            next();
        },
        beforeMount() {
            console.log("====",this.global.userModel)
        },
        mounted() {


            this.isMounted = true;

            let _this = this
            let id = _this.$route.query.userId
            _this.userId = id

            let showIndex = _this.$route.query.showIndex
            if (id && parseInt(id) !== 0) {
                _this.userId = id
            }
            console.log("showIndex="+showIndex)
            if(showIndex == 1){
                this.status = 1
                this.showIndex = 1
            }

            if (_this.global.userModel != null) {
                _this.currentUserId = _this.global.userModel.id
            }

            console.log("userId=" + _this.userId)
            console.log("currentUserId=" + _this.currentUserId)

            this.callbackurl = "login?callback=" + window.location.href;


            let thiss = this
            const alreadyIncremented = !!this.productionDetail;
            if (!alreadyIncremented) {
                this.fetchData().then(
                    setTimeout(function (){
                        thiss.initData()
                    },1000)
                );
            } else {
                setTimeout(function (){
                    thiss.initData()
                },1000)
            }



        },
        methods: {
            fetchData(){
                return this.$store
                    .dispatch("FETCH_USER_DETAIL", {
                        id: this.$route.query.userId
                    })
                    .finally(() => {
                        this.$loading(false);
                        this.setSeo()
                        updateTdk.call(this);
                    });
            },
            initData(){
                console.log("haoypuo===this.userId=====>",this.userId)
                console.log("haoypuo===this.currentUserId=====>",this.currentUserId)
                console.log("haoypuo===userModel=====>",this.global.userModel)
                if (this.global.userModel != null) {
                    this.currentUserId = this.global.userModel.id
                }
                this.getUndoNum()
                this.statusList(1)
            },
            setSeo(){
                this.headTitle = this.userDetail.userName+"的好友——人人动画网【官网】";
              this.headKeywords = this.userDetail.impressStr;
                this.headDesc =this.userDetail.userName+"的好友";
            },
            showEvent(num) {
                this.getUndoNum()
                this.pageIndex = 1
                this.total = 0
                this.tableData = []
                this.showIndex = num
                if (num == 3) {
                    this.username = ''
                } else if (num == 2) {
                    this.status = 4
                    this.statusList(1)
                } else if (num == 1) {
                    this.status = 1
                    this.statusList(1)
                } else if (num == 0) {
                    this.status = 2
                    this.statusList(1)
                } else if(num == 4){
                    this.blackList(1)
                }
            },
            getUndoNum() {
                let _this = this;
                let url = '/rrbi/friends/undoNum' + "?ti=" + new Date().getMilliseconds();
                _this.$axios.get(url).then(function (result) {
                    console.log(result)
                    _this.undoNum = result.data.response
                })
            },
            search(page) {
                let _this = this;
                if (_this.username == '') {
                    _this.$message.error("请输入名字")
                    return
                }

                if (_this.global.isLogin) {
                    _this.pageIndex = page;
                    _this.fullscreenLoading = true;
                    let url = '/rrbi/friends/search?userName=' + _this.username + '&pageIndex=' + _this.pageIndex + '&pageSize=' + _this.pageSize + "&ti=" + new Date().getMilliseconds();
                    _this.$axios.get(url).then(function (result) {
                        console.log(result)
                        _this.tableData = result.data.response.list
                        _this.total = result.data.response.total
                        _this.fullscreenLoading = false
                    })
                }
            },
            addFriend(item, index) {
                let _this = this;
                if (_this.global.isLogin) {
                    let url = '/rrbi/friends/add/' + item.friendId + "?ti=" + new Date().getMilliseconds();
                    _this.$axios.get(url).then(function (result) {
                        console.log(result)
                        if (result.data.response.code == 1) {
                            _this.$message.success(result.data.response.msg)
                            _this.tableData[index].friendStatus = 1
                        } else {
                            _this.$message.error(result.data.response.msg)
                        }
                    })
                }
            },
            statusList(page) {
                let _this = this;
                if (_this.global.isLogin) {
                    _this.pageIndex = page;
                    _this.fullscreenLoading = true;
                    let url = '/rrbi/friends/list?status=' + _this.status + '&pageIndex=' + _this.pageIndex + '&pageSize=' + _this.pageSize + "&ti=" + new Date().getMilliseconds();
                    _this.$axios.get(url).then(function (result) {
                        console.log(result)
                        _this.tableData = result.data.response.list
                        _this.total = result.data.response.total
                        _this.fullscreenLoading = false
                    })
                }
            },
            updateStatus(item, index, status) {
                let _this = this;
                if (_this.global.isLogin) {
                    let url = '/rrbi/friends/update?fid=' + item.friendId + "&status=" + status + "&ti=" + new Date().getMilliseconds();
                    _this.$axios.get(url).then(function (result) {
                        console.log(result)
                        if (result.data.response == 1) {
                            _this.tableData.splice(index, 1)
                            _this.total = _this.tableData.length
                        } else {
                            _this.$message.error("请求异常，请稍后再试")
                        }
                        _this.getUndoNum()
                    })
                }
            },
            delFriend(item, index) {
                let _this = this;
                if (_this.global.isLogin) {
                    let url = '/rrbi/friends/del/' + item.friendId + "?ti=" + new Date().getMilliseconds();
                    _this.$axios.get(url).then(function (result) {
                        console.log(result)
                        if (result.data.response == 1) {
                            _this.tableData.splice(index, 1)
                            _this.total = _this.tableData.length
                        } else {
                            _this.$message.error("请求异常，请稍后再试")
                        }
                    })

                }
            },
            blackFriend(item, index) {
                let _this = this;
                if (_this.global.isLogin) {
                    let url = '/rrbi/friends/black/' + item.friendId + "?ti=" + new Date().getMilliseconds();
                    _this.$axios.get(url).then(function (result) {
                        console.log(result)
                        if (result.data.response == 1) {
                            _this.tableData.splice(index, 1)
                            _this.total = _this.tableData.length
                        } else {
                            _this.$message.error("请求异常，请稍后再试")
                        }
                    })
                }
            },
            delBlack(item, index) {
                let _this = this;
                if (_this.global.isLogin) {
                    let url = '/rrbi/friends/delBlack/' + item.friendId + "?ti=" + new Date().getMilliseconds();
                    _this.$axios.get(url).then(function (result) {
                        console.log(result)
                        if (result.data.response == 1) {
                            _this.tableData.splice(index, 1)
                            _this.total = _this.tableData.length
                        } else {
                            _this.$message.error("请求异常，请稍后再试")
                        }
                    })
                }
            },
            blackList(page) {
                let _this = this;
                if (_this.global.isLogin) {
                    _this.pageIndex = page;
                    _this.fullscreenLoading = true;
                    let url = '/rrbi/friends/blackList' + '?pageIndex=' + _this.pageIndex + '&pageSize=' + _this.pageSize + "&ti=" + new Date().getMilliseconds();
                    _this.$axios.get(url).then(function (result) {
                        console.log(result)
                        _this.tableData = result.data.response.list
                        _this.total = result.data.response.total
                        _this.fullscreenLoading = false
                    })
                }
            }
        }
    }
</script>

<style scoped lang="less">
   //@import "../../../assets/less/stylePublic.less";

    .cont-haoyou {
        .user-much-num {
            li {
                float: left;
                margin-right: 20px;
                font-size: 14px;
                cursor: pointer;

                &.active {
                    position: relative;

                    &:after {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        content: '';
                        display: block;
                        width: 100%;
                        height: 2px;
                        background: #515151;
                    }
                }

                &.red {
                    span {
                        position: relative;

                        &:after {
                            position: absolute;
                            right: -5px;
                            top: -5px;
                            content: '';
                            display: block;
                            width: 8px;
                            height: 8px;
                            background: #ff0000;
                            border-radius: 50%;
                        }
                    }
                }
            }
        }

        .jiahaoyou-list {
            padding-top: 10px;

            .search-user-ipt {
                margin: 0 10px;
            }
        }
    }

    @media screen and (max-width: 750px) {
        .cont-haoyou {
            margin-top: 30px;

            .user-much-num {
                top: -30px !important;
                line-height: 30px !important;
            }
        }
    }

    .pagintion-f {
        padding: 20px 0 40px;
        text-align: center;
    }
</style>
